import { Component } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
  selector: "app-add-account-signature",
  templateUrl: "./add-account-signature.component.html",
  standalone: false,
})
export class AddAccountSignatureComponent {
  currentAccountId: number;
  isReadDataFromSassEnabled: boolean = false;
}
